<script setup lang="ts">
import { NewProductTag } from '@/types/api/api-v4/product'
import { ProductParentType } from '@/types/components/product-card.types'

type Props = {
  mainTags: NewProductTag[]
  additionalTags: NewProductTag[]
  type: ProductParentType
}

const props = defineProps<Props>()

const componentClasses = [
  'product-tag-extra',
  `product-tag-extra--type-${props.type}`,
]

const filteredTag = computed(() => {
  // По умолчанию ищем is_extra среди основных тегов
  const tags = [...props.mainTags]

  // Если это детальная страница товара или ДО товара, то ищем среди основных и дополнительных тегов
  if (props.type === ProductParentType.detail) {
    tags.push(...props.additionalTags)
  }

  return tags.find((tag) => tag.is_extra)
})
</script>

<template>
  <nuxt-img
    v-if="filteredTag"
    :class="componentClasses"
    :src="filteredTag.image"
    :alt="filteredTag.name"
  />
</template>

<style lang="scss" scoped>
.product-tag-extra--type-card {
  width: 12px;
  height: 12px;
}

.product-tag-extra--type-detail {
  width: 14px;
  height: 14px;
}
</style>
